module.exports = __webpack_public_path__ + "media/images/illustrations/cargo_van_crop_small-a0c9faa34e82adef00c2b3f2db1e9b4c.svg";